import { Box, Heading, Text } from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';

export default function SmallScreenAlert() {
  return (
    <Box
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      borderWidth="1px"
      textAlign="center"
      p={6}
      m={8}
      maxW={{ base: 'none', md: 'sm' }}
      alignSelf="center"
    >
      <WarningTwoIcon boxSize={'50px'} color={'orange.300'} />
      <Heading as="h2" size="xl" mt={6} mb={2}>
        Small Screen Alert
      </Heading>
      <Text color={'gray.500'}>
        We noticed your screen size might be a little snug for this content. For
        the best experience, we kindly recommend switching to a larger device.
        Sorry for the inconvenience!
      </Text>
    </Box>
  );
}
